import { BuyConsiderationSection } from "./view";
export default BuyConsiderationSection;
